import Vue from "vue"
import Router from "vue-router"
import { getCookie } from "common/js/mUtils.js"


var Login = () => import('views/Login.vue') // 登录页面
var LeftMenu = () => import('components/LeftMenu.vue') // 左侧的菜单栏
var MarkPeople = () => import('views/MarkPeople.vue') // 市场人员
var TransceiverStaff = () => import('views/TransceiverStaff.vue') // 收发人员
var EngineerPeople = () => import('views/EngineerPeople.vue') // 工程师
var AddAccount = () => import('views/AddAccount.vue') // 添加账号
var EngineerCan = () => import('views/EngineerCan.vue') // 工程师能力

/* 市场人员 客户资料 */
var MarkCustomer = () => import('views/mark/MarkCustomer.vue')
var OrderComplete = () => import('views/mark/OrderComplete.vue') // 完成 委托单
var OrderAddDevice = () => import('views/mark/OrderAddDevice.vue') // 创建委托单 添加仪器
var OrderNoComplete = () => import('views/mark/OrderNoComplete.vue') // 未完成 委托单
var OrderOtherComplete = () => import('views/mark/OrderOtherComplete.vue') // 委外完成 委托单
var OrderHistory = () => import('views/mark/OrderHistory.vue') // 历史委托单
var OrderDetail = () => import('views/mark/OrderDetail.vue') // 订单详情
var OrderRemind = () => import('views/mark/OrderRemind.vue') // 提醒送检
var OrderSearch = () => import('views/mark/OrderSearch.vue') // 订单搜索

/* 工程师 */
var EngineerOrder = () => import('views/engineer/EngineerOrder.vue') // 工程师未领委托单列表
var EngineerOrderDeviceList = () => import('views/engineer/EngineerOrderDeviceList.vue') //工程师未领委托单仪器列表
var EngineerOrderHas = () => import('views/engineer/EngineerOrderHas.vue') // 工程师已领委托单列表
var EngineerOrderHasList = () => import('views/engineer/EngineerOrderHasList.vue') // 工程师已领委托单仪器列表
var EngineerOrderVerification = () => import('views/engineer/EngineerOrderVerification.vue') // 工程师核验订单仪器列表
var EngineerOrderApprove = () => import('views/engineer/EngineerOrderApprove.vue') // 工程师批准仪器列表
var ManagementRegulations = () => import('views/engineer/ManagementRegulations.vue') // 规程管理
var StandardManage = () => import('views/engineer/StandardManage.vue') // 标准计量器具管理
var StencilList = () => import('views/engineer/StencilList.vue') // 证书模版
var EngineerWorkOrderOut = () => import('views/engineer/EngineerWorkOrderOut.vue') // 委外送检未领 委托单
var EngineerReceivedOrderOut = () => import('views/engineer/EngineerReceivedOrderOut.vue') // 委外送检 已领委托单
var RevertCert = () => import('views/engineer/RevertCert.vue') // 退回正式证书，客户要求修改

// 收发
var WorkOutScan = () => import('views/shoufa/WorkOutScan.vue') // 委外送检扫码
var WorkReceiveScan = () => import('views/shoufa/WorkReceiveScan.vue') // 委外签收扫码
var WorkSendScan = () => import('views/shoufa/WorkSendScan.vue') // 客户返样扫码
var Phone = () => import('views/Phone.vue') // 手机观看

// 财务
var Finance = () => import('views/Finance.vue') // 财务人员
var ContractCus = () => import('views/finance/ContractCus.vue') // 合同客户 未付费
var ContractCusPay = () => import('views/finance/ContractCusPay.vue') // 合同客户 已付费
var CompletePay = () => import('views/finance/CompletePay.vue') // 付费委托单
var NoPay = () => import('views/finance/NoPay.vue') // 未付费委托单

Vue.use(Router);

const routersList = [
  {
    path: "/",
    name: "login",
    component: Login // 登录
  }, {
    path: '/markPeople',
    name: '',
    component: LeftMenu,
    children: [{
      path: '',
      name: 'markPeople',
      component: MarkPeople,
      meta: {
        title: '账户',
        breadcrumb: [
          {
            name: '市场人员',
            path: '/markPeople'
          }
        ],
        menu: ['账户', '市场人员'],
        requireAuth: true
      }
    }, {
      path: '/engineerPeople',
      name: 'engineerPeople',
      component: EngineerPeople,
      meta: {
        title: '账户',
        breadcrumb: [
          {
            name: '工程师',
            path: '/engineerPeople'
          }
        ],
        menu: ['账户', '工程师'],
        requireAuth: true
      }
    }, {
      path: '/transceiverStaff',
      name: 'transceiverStaff',
      component: TransceiverStaff,
      meta: {
        title: '账户',
        breadcrumb: [
          {
            name: '收发人员',
            path: '/transceiverStaff'
          }
        ],
        menu: ['账户', '收发人员'],
        requireAuth: true
      }
    },
    {
      path: '/finance',
      name: 'finance',
      component: Finance,
      meta: {
        title: '账户',
        breadcrumb: [
          {
            name: '财务账户',
            path: '/finance'
          }
        ],
        menu: ['账户', '财务账户'],
        requireAuth: true
      }
    },
    {
      path: '/engineerCan',
      name: 'engineerCan',
      component: EngineerCan,
      meta: {
        title: '账户',
        breadcrumb: [
          {
            name: '工程师',
            path: '/engineerPeople'
          },
          {
            name: '能力',
            path: '/engineerCan'
          }
        ],
        menu: ['账户', '工程师', '能力'],
        requireAuth: true
      }
    }, {
      path: '/addAccount',
      name: 'addAccount',
      component: AddAccount,
      meta: {
        title: '账户',
        breadcrumb: [
          {
            name: '添加账户',
            path: '/addAccount'
          }
        ],
        menu: ['账户', '添加账户'],
        requireAuth: true
      }
    }]
  },
  {
    path: '/markCustomer',
    name: '',
    component: LeftMenu,
    children: [{
      path: '',
      name: 'markCustomer',
      component: MarkCustomer,
      meta: {
        title: '客户资料',
        breadcrumb: [
          {
            name: '信息',
            path: '/markCustomer'
          }
        ],
        menu: ['客户资料', '信息'],
        requireAuth: true
      }
    }, 
    {
      path: '/orderComplete',
      name: 'orderComplete',
      component: OrderComplete,
      meta: {
        title: '订单',
        breadcrumb: [
          {
            name: '已完成订单',
            path: '/orderComplete'
          }
        ],
        menu: ['客户资料', '信息'],
        requireAuth: true
      }
    }, 
    {
      path: '/orderOtherComplete',
      name: 'orderOtherComplete',
      component: OrderOtherComplete,
      meta: {
        title: '订单',
        breadcrumb: [
          {
            name: '委外完成订单',
            path: '/orderOtherComplete'
          }
        ],
        menu: ['客户资料', '信息'],
        requireAuth: true
      }
    }, 
    {
      path: '/orderAddDevice/:order_id',
      name: 'orderAddDevice',
      component: OrderAddDevice,
      meta: {
        title: '订单',
        breadcrumb: [
          {
            name: '创建订单添加仪器',
            path: '/orderAddDevice/:order_id'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/orderNoComplete',
      name: 'orderNoComplete',
      component: OrderNoComplete,
      meta: {
        title: '订单',
        breadcrumb: [
          {
            name: '未完成订单',
            path: '/orderNoComplete'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/orderHistory',
      name: 'orderHistory',
      component: OrderHistory,
      meta: {
        title: '订单',
        breadcrumb: [
          {
            name: '历史订单',
            path: '/orderHistory'
          }
        ],
        requireAuth: true
      }
    }, 
    {
      path: '/orderRemind',
      name: 'orderRemind',
      component: OrderRemind,
      meta: {
        title: '订单',
        breadcrumb: [
          {
            name: '提醒送检',
            path: '/orderRemind'
          }
        ],
        requireAuth: true
      }
    }, 
    {
      path: '/orderSearch',
      name: 'orderSearch',
      component: OrderSearch,
      meta: {
        title: '订单搜索',
        breadcrumb: [
          {
            name: '订单搜索',
            path: '/orderSearch'
          }
        ],
        requireAuth: true
      }
    }, 
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: OrderDetail,
      meta: {
        title: '订单',
        breadcrumb: [
          {
            name: '订单详情',
            path: '/orderDetail'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerOrder',
      name: 'engineerOrder',
      component: EngineerOrder,
      meta: {
        title: '工作订单',
        breadcrumb: [
          {
            name: '未领订单',
            path: '/engineerOrder'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerOrderDeviceList',
      name: 'engineerOrderDeviceList',
      component: EngineerOrderDeviceList,
      meta: {
        title: '工作订单未领',
        breadcrumb: [
          /* {
            name: '未领订单',
            path: '/engineerOrder'
          }, */
          {
            name: '仪器列表',
            path: '/engineerOrderDeviceList'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerOrderHas',
      name: 'engineerOrderHas',
      component: EngineerOrderHas,
      meta: {
        title: '工作订单',
        breadcrumb: [
          {
            name: '已领订单',
            path: '/engineerOrderHas'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerOrderHasList',
      name: 'engineerOrderHasList',
      component: EngineerOrderHasList,
      meta: {
        title: '工作订单已领',
        breadcrumb: [
          /* {
            name: '已领订单',
            path: '/engineerOrderHas'
          }, */ {
            name: '仪器列表',
            path: '/engineerOrderHasList'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerWorkOrderOut',
      name: 'engineerWorkOrderOut',
      component: EngineerWorkOrderOut,
      meta: {
        title: '工作订单',
        breadcrumb: [
          {
            name: '委外未领订单',
            path: '/engineerWorkOrderOut'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerReceivedOrderOut',
      name: 'engineerReceivedOrderOut',
      component: EngineerReceivedOrderOut,
      meta: {
        title: '工作订单',
        breadcrumb: [
          {
            name: '委外已领订单',
            path: '/engineerReceivedOrderOut'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerOrderVerification',
      name: 'engineerOrderVerification',
      component: EngineerOrderVerification,
      meta: {
        title: '核验订单',
        breadcrumb: [
          {
            name: '仪器列表',
            path: '/engineerOrderVerification'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/engineerOrderApprove',
      name: 'engineerOrderApprove',
      component: EngineerOrderApprove,
      meta: {
        title: '批准订单',
        breadcrumb: [
          {
            name: '仪器列表',
            path: '/engineerOrderApprove'
          }
        ],
        requireAuth: true
      }
    }, 
    {
      /* ManagementRegulations */
      path: '/managementRegulations',
      name: 'managementRegulations',
      component: ManagementRegulations,
      meta: {
        title: '规程管理',
        breadcrumb: [
          {
            name: '管理列表',
            path: '/managementRegulations'
          }
        ],
        requireAuth: true
      }
    },
    {
      /* RevertCert */
      path: '/revertCert',
      name: 'revertCert',
      component: RevertCert,
      meta: {
        title: '退回证书',
        breadcrumb: [
          {
            name: '证书列表',
            path: '/revertCert'
          }
        ],
        requireAuth: true
      }
    },
    {
      path: '/standardManage',
      name: 'standardManage',
      component: StandardManage,
      meta: {
        title: '标准器具管理',
        breadcrumb: [
          {
            name: '管理列表',
            path: '/standardManage'
          }
        ],
        requireAuth: true
      }
    },  {
      path: '/stencilList',
      name: 'stencilList',
      component: StencilList,
      meta: {
        title: '证书模版',
        breadcrumb: [
          {
            name: '模版列表',
            path: '/stencilList'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/workOutScan',
      name : 'workOutScan',
      component: WorkOutScan,
      meta: {
        title: '委外送检扫码',
        requireAuth: true
      }
    }, {
      path: '/workReceiveScan',
      name : 'workReceiveScan',
      component: WorkReceiveScan,
      meta: {
        title: '委外签收扫码',
        requireAuth: true
      }
    }, {
      path: '/workSendScan',
      name : 'workSendScan',
      component: WorkSendScan,
      meta: {
        title: '客户返样扫码',
        requireAuth: true
      }
    }]
  }, {
    path: "/phone",
    name: "phone",
    component: Phone
  }, {
    path: '/contractCus',
    name: '',
    component: LeftMenu,
    children: [{
      path: '',
      name: 'contractCus',
      component: ContractCus,
      meta: {
        title: '合同客户',
        breadcrumb: [{
          name: '未付费委托单',
          path: '/contractCus'
        }],
        menu: ['合同客户', '未付费委托单'],
        requireAuth: true
      }
    }, {
      path: '/contractCusPay',
      name: 'contractCusPay',
      component: ContractCusPay,
      meta: {
        title: '合同客户',
        breadcrumb: [{
          name: '已付费委托单',
          path: '/contractCusPay'
        }],
        menu: ['合同客户', '已付费委托单'],
        requireAuth: true
      }
    }, {
      path: '/completePay',
      name: 'completePay',
      component: CompletePay,
      meta: {
        title: '已付费委托单',
        meta: ['普通客户', '已付费委托单'],
        breadcrumb: [{
          name: '已付费委托单',
          path: '/completePay'
        }],
        requireAuth: true
      }
    }, {
      path: '/noPay',
      name: 'noPay',
      component: NoPay,
      meta: {
        title: '未付费委托单',
        meta: ['普通客户', '未付费委托单'],
        breadcrumb: [{
          name: '未付费委托单',
          path: '/noPay'
        }],
        requireAuth: true
      }
    }]
  }
];

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: routersList
});

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    let userId = getCookie("u_uuid_userId");
    if (!userId) {
      next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
